import { styled } from '@mui/material/styles';

export const Paper = styled('div')(({ theme }) => ({
  margin: theme.spacing(4, 0),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const Form = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
  marginTop: theme.spacing(1),
}));

export const Submit = styled('div')(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

export const Typo = styled('div')(() => ({
  width: '100%',
  textTransform: 'uppercase',
}));

// navlink active/inactive
export const NavLinkActive = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

export const NavLinkInactive = styled('span')(() => ({
  color: '#C8C8C8',
  cursor: 'pointer',
}));

// --- Styled-components (already good) --- //

export const FormFooter = styled('div')`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const AttachmentContainer = styled('div')`
  align-items: center;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin: 20px 0px 10px 0px;
  cursor: pointer;
`;

export const FileUploadComponent = styled('input')`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;
